/**
 * RegistrationStepUserName Component
 */

import { setUserDetail } from '../../../../redux/actions/user';
import './styles.scss';

import { trim } from 'lodash';
import * as React from 'react';
import * as BEM from 'react-bem-helper';
import { connect } from 'react-redux';
import * as Velocity from 'velocity-animate';
import { VelocityTransitionGroup } from 'velocity-react';

import Button from '../../../atoms/buttons/Button';
import Heading from '../../../atoms/text/Heading';
import { Span } from '../../../atoms/text/Label';

interface IOwnDispatchProps {
  setUserName: (firstName: string, lastName: string) => void;
}

interface IOwnProps {
  onComplete: () => void;
}

interface IOwnState {
  error: string;
  nameInput: string;
  userFirstName: string | undefined;
  userLastName: string;
}

type RegistrationStepUserNameProps = IOwnProps & IOwnDispatchProps;

const classes = new BEM('account-registration');

class RegistrationStepUserName extends React.Component<RegistrationStepUserNameProps, IOwnState> {
  private input: HTMLInputElement;

  constructor(props) {
    super(props);
    this.state = {
      error: '',
      nameInput: '',
      userFirstName: '',
      userLastName: '',
    };
  }

  componentDidMount() {
    setTimeout(() => {
      this.input.focus();
      this.forceUpdate();
    }, 500);
  }

  onNameInputChange(nameInput: string) {
    const firstNameIsSet = trim(nameInput).match(/(\S{2,})/);
    const userFirstName = this.state.userFirstName ?
      this.state.userFirstName :
      (firstNameIsSet ? firstNameIsSet[1] : undefined);
    const error = this.state.error && !userFirstName ? this.state.error : '';
    this.setState({
      error,
      nameInput,
      userFirstName,
    });
  }

  onNameInputKeyDown(key, input: HTMLInputElement) {
    if (key === 'Enter') {
      this.nextStep();
    }
  }

  nextStep() {
    if (this.state.userFirstName && this.state.userFirstName !== '') {
      const userFullName = trim(this.state.nameInput).match(/(\S+)\s?(.*)$/)!;
      this.props.setUserName(userFullName[1], userFullName[2]);
      setTimeout(this.props.onComplete, 0);
    } else {
      this.setState({
        error: `This field is required.`,
      }, () => {
        Velocity(this.input, 'callout.shake', { duration: 500 });
      });
    }
  }

  onClickNext(e) {
    this.nextStep();
  }

  render() {
    const {
      error,
    } = this.state;

    return (
      <div {...classes('step', 'user-name')}>
        <Heading is="h3"  {...classes('step__title')}>Enter your full name:</Heading>
        <input
          ref={(node) => this.input = node!}
          name="fullname"
          onChange={({ target }) => this.onNameInputChange(target.value)}
          onKeyDown={({ key, target }) => this.onNameInputKeyDown(key, target as HTMLInputElement)}
          onBlur={() => setTimeout(() => this.input.focus(), 100)}
          placeholder="First and last name"
          type="text"
          value={this.state.nameInput}
          {...classes('textfield')}
        />
        <VelocityTransitionGroup
          component="div"
          className="input-message"
          enter={{ animation: 'transition.fadeIn', duration: 500 }}
        >
          <div>
            <Span variant="note" size="medium">
              Hit enter when you're done.
            </Span>
          </div>
          {error && <Span variant="note" size="medium" textColor="dangerous">{error}</Span>}
          <br /><br />
          <Button
            onClick={(e) => this.onClickNext(e)}
            label="Next"
            colorScheme="dark"
            size="medium"
          />
        </VelocityTransitionGroup>
      </div>
    );
  }
}

const ConnectedRegistrationStepUserName = connect<{}, IOwnDispatchProps, IOwnProps>(
  null,
  (dispatch) => ({
    setUserName: (firstName, lastName) => {
      dispatch(setUserDetail({ key: 'firstName', value: firstName }));
      dispatch(setUserDetail({ key: 'lastName', value: lastName }));
    },
  }),
)(RegistrationStepUserName);

export default ConnectedRegistrationStepUserName;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/pages/account/Registration/RegistrationStepUserName.tsx